import React, { useContext, useEffect, useState } from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import Icon from '../forms/Icon';
import { MenuContext } from './Body';
import RoleProtected from '../RoleProtected';
import { SCREEN_WIDTH } from '../../constants/config';

const Wrapper = styled.div`
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: fit-content;
    margin-left: 4px;
`;

const SubMenu = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin-left: 1em;
    padding-left: 1em;
    border-left: 2px solid ${({ theme }) => theme.highlight}40;
    transition: max-height 0.5s;
    max-height: ${({ isparentactive }) => isparentactive ? '1500px' : '0'};
    overflow: hidden;

    font-size: 0.9em;
    gap: 0.2em;
`;

const Button = styled(Link)`
    display: flex;
    align-items: center;
    text-decoration: none;
    display: flex;
    align-items: center;
    border-radius: 5rem;
    white-space: nowrap;
    margin-bottom: 0.2rem;
    color:  ${({ current, theme }) => current ? theme.tertiary : 'inherit'};
    background: ${({ current, theme }) => current ? `${theme.secondary}20` : 'unset'};

    &:hover {
        transition: all, 0.5s;
        background-color: ${({ theme }) => theme.highlight}40;
    }
`

const IconWrapper = styled.div`
    color: inherit;
    font-size: 1.5rem;
    width: 2rem;
    padding: 0.5rem;
    text-align: center;
`;

const Label = styled.div`
    cursor: pointer;
    transition: 0.5s;
    transition-property: all, 0.5s;
    opacity: 0;
    max-width: 0;
    overflow: hidden;
    font-weight: ${({ hasitems }) => hasitems ? 'bold' : ''};

    opacity: ${({ open }) => open ? '1' : '0'};
    max-width: ${({ open }) => open ? '220px' : '0px'};
    padding: ${({ open }) => open ? '0.3em 0.5em' : '0'};
`

const Chevron = styled(Icon)`
    padding: 0 0.5em;
    transition: transform .3s;
    transform: rotate(${({ open }) => open ? '-180deg' : '0deg'});
`;


const MenuItem = ({ isparentactive, ...props }) => {
    const { isOpen, setIsOpen } = useContext(MenuContext);
    const [expanded, setExpanded] = useState(false);

    const basePath = process.env.PUBLIC_URL;
    const isCurrent = (current) => {
        if (!current) return 0;
        const currentPath = window.location.pathname.replace(basePath, '');
        return currentPath.length === 1 || current.length === 1
            ? currentPath === current ? 1 : 0
            : pathMatching(currentPath.split('/'), current.split('/')) ? 1 : 0
    };

    const pathMatching = (current, pointer) => {
        for (let i = 0; i < pointer.length; i++) {
            if (pointer[i] !== current[i]) {
                return false;
            }
        }
        return true;
    }

    useEffect(() => {
        if (!isOpen)
            setExpanded(false);
    }, [isOpen])

    useEffect(() => {
        if (!isparentactive)
            setExpanded(false)
    }, [isparentactive])

    return (
        <Wrapper open={isOpen}>
            {props.path ?
                <RoleProtected roles={props.role}>
                    <Button
                        to={props.path}
                        icon={props.icon}
                        open={isOpen}
                        current={isCurrent(props.path)}
                        onClick={() => { if (SCREEN_WIDTH) setIsOpen(false) }}
                        {...props}
                        role='link'
                    >
                        {props.icon && <IconWrapper><Icon icon={props.icon} /></IconWrapper>}
                        <Label open={isOpen}>{props.label}</Label>
                    </Button>
                </RoleProtected> :
                <Button
                    onClick={() => {
                        setIsOpen(true)
                        setExpanded(!expanded)
                    }}
                    open={isOpen}
                    current={isCurrent(props.route)}
                    {...props}
                    role='button'
                >
                    {props.icon && <IconWrapper><Icon icon={props.icon} /></IconWrapper>}
                    <Label
                        open={isOpen}
                        hasitems={props.items ? 1 : 0}
                    >
                        {props.label}
                        {props.items && <Chevron icon='chevronDown' open={expanded} />}
                    </Label>
                </Button>
            }
            <SubMenu isparentactive={expanded}>
                {props.items && props.items.map((e, i) => <MenuItem key={`${props.label}-${i}`} {...e} />)}
            </SubMenu>
        </Wrapper>
    );
}

export default MenuItem;
